import { render, staticRenderFns } from "./MantenimientoConfig.vue?vue&type=template&id=aa3fa70e&"
import script from "./MantenimientoConfig.vue?vue&type=script&lang=js&"
export * from "./MantenimientoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports